// extracted by mini-css-extract-plugin
export default {"Body1":"TaskApp_Body1__VIkny","DaySeparator":"TaskApp_DaySeparator__K-lSE","Sentinel":"TaskApp_Sentinel__6ynSz","LoadMoreSpinner":"TaskApp_LoadMoreSpinner__Jk9eE"};